var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import superagent from "superagent";
import throttle from "lodash/throttle";
var methods = ["get", "post", "put", "patch", "del"];
var errorPath = "riotpay/pmc/v1/client-logs/error";
function formatUrl(pmcCoreHost, instance, path) {
    // production pmc edge has multiple instances (config url will contain '{}' token)
    // but local and stage pmc edge have but one instance (so no token would be in config url)
    var pmcCoreHostInstance = pmcCoreHost.replace("{}", instance);
    var adjustedPath = path[0] !== "/" ? "/" + path : path;
    return "" + pmcCoreHostInstance + adjustedPath;
}
/* Formats http requests and converts it to Promises */
var ApiClient = /** @class */ (function () {
    function ApiClient(pmcCoreHost) {
        var _this = this;
        methods.forEach(function (method) {
            return (_this[method] = function (path, _a) {
                var _b = _a === void 0 ? {} : _a, params = _b.params, data = _b.data, token = _b.token, instance = _b.instance, useApiV2 = _b.useApiV2;
                return new Promise(function (resolve, reject) {
                    var request = superagent[method](formatUrl(pmcCoreHost, instance, path));
                    if (useApiV2) {
                        if (token) {
                            request.set("Authorization", "Session " + token);
                        }
                        if (params) {
                            request.query(params);
                        }
                        if (data) {
                            request.set("Content-Type", "application/json");
                            request.send(data);
                        }
                    }
                    else {
                        if (!params && !data) {
                            request.query({
                                pid: token
                            });
                        }
                        if (params) {
                            request.query(__assign(__assign({}, params), { pid: token }));
                        }
                        if (data) {
                            request.set("Content-Type", "application/json");
                            request.send(__assign(__assign({}, data), { pid: token }));
                        }
                    }
                    request.end(function (err, res) {
                        if (err) {
                            var error = {};
                            error.data = res && res.text ? res.text : err;
                            error.status = err.status || err.response;
                            reject(error);
                        }
                        else {
                            resolve(res.body);
                        }
                    });
                });
            });
        });
        this.throttleLogError = throttle(function (m, a, t) {
            return _this.post(errorPath, {
                data: {
                    token: t,
                    message: m,
                    action: a
                }
            }).catch(function (err) {
                // Do not treat session expiration (HTTP 401) as an error
                if (err.status !== 401) {
                    // console.error('Unable to report error:', err)
                }
            });
        }, 10000, { leading: true });
    }
    // Sends first error request right away and then make sure we don't send the same
    // error less than 10 seconds again.
    ApiClient.prototype.logError = function (token) {
        return function (message, action) {
            this.throttleLogError(message, action, token);
        };
    };
    /*
     * There's a V8 bug where, when using Babel, exporting classes with only
     * constructors sometimes fails. Until it's patched, this is a solution to
     * "ApiClient is not defined" from issue #14.
     * https://github.com/erikras/react-redux-universal-hot-example/issues/14
     *
     * Relevant Babel bug (but they claim it's V8): https://phabricator.babeljs.io/T2455
     *
     * Remove it at your own risk.
     */
    ApiClient.prototype.empty = function () { };
    return ApiClient;
}());
export { ApiClient };
//# sourceMappingURL=apiClient.js.map